export const environment = {
  production: false,
  //apiSecurityUrl: 'http://localhost:4000/',
  apiSecurityUrl: 'https://dsc.icg.com.bo/dsc-security/',
  encryptSecretKey: 'pzR4I965QMWmFP2P2yUVkBwJt0NLDcRO'
}